export const aboutPagesArray = [
  {
    name: 'Operation Locations',
    buttonLabel: 'Explore Operation Locations',
    pageAddress: '/admin/operation-location',
    paragraphs: [
      'Each Client (example - Chemmanur) can have a state/regions divided into multiple operation locations.',
      'Each Branch from Company section is to be associated with an Operation Location, without a pre existing Operation Location a Branch can not be created. ',
    ],
  },
  {
    name: 'Branches',
    buttonLabel: 'See Companies',
    pageAddress: '/admin/companies',
    paragraphs: [
      'Every Branch is associated to a Company and an Operation Location. Branches associated to a company can be found inside that company page.',
      'To make a Branch, go to a pre existing company page then go to Branches tab and add the store under that company. Branches can only be made if there is atleast 1 Company and atleast 1 Operation location.',
    ],
  },
  {
    name: 'Bullion Desk',
    buttonLabel: 'Explore Bullion Desk',
    pageAddress: '/admin/bullion-desks',
    paragraphs: [
      'This module will be used by clients through the client admin panel to update the current gold price , silver etc.',
      'The price of gold is set as per operation location.',
    ],
  },
  {
    name: 'Bullion Config',
    buttonLabel: 'Explore Bullion Config',
    pageAddress: '/admin/bullion-config',
    paragraphs: ['The underlying Configuration for any Bullion Desk.'],
  },
  {
    name: 'Saving Plan Variants',
    buttonLabel: 'See Saving Plan Variants',
    pageAddress: '/admin/savingsplanvariant',
    paragraphs: [
      'Each Saving plan can have multiple variants with different time periods and properties.',
      "A Saving Plan's Variant can only be created if that Saving Plan already exists.",
    ],
  },
  {
    name: 'Saving Plan Branches',
    buttonLabel: 'Explore Saving Plan Branches',
    pageAddress: '/admin/variantstores',
    paragraphs: [
      'This Module have the information about which Saving Plan Variant is available at which Branch.',
      'Multiple Saving plan variants can be assigned to any Branch from this module.',
    ],
  },
  {
    name: 'Permission Groups',
    buttonLabel: 'Explore Permission Groups',
    pageAddress: '/admin/permissiongroups',
    paragraphs: [
      'There could be multiple permissions alloted to a Permission Group',
    ],
  },
];
